/* eslint-disable @typescript-eslint/no-explicit-any */ import { useContext } from 'react';
import { BreadcrumbContext } from '../common/Breadcrumb';
export var useBreadcrumb = function() {
    return useContext(BreadcrumbContext);
};
